import { useTranslation } from 'react-i18next';
import {
  useFormContext,
  type Control,
  type FieldValues,
} from 'react-hook-form';
import { Box, styled } from '@mui/material';

import DateInput from '@/components/forms/DateInput';

import type { ReservationFormInput } from '../schema/reservationForm.schema';
import {
  type TripArrayFieldKey,
  useReservationFormMachines,
} from '../ReservationFormMachinesContext';
import { useFieldActorSnapshot } from '../useFieldActorSnapshot';

const PREFIX = 'TripArrayFieldDateInput';

const classes = {
  container: `${PREFIX}-container`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    '& > *': { flex: '1 1 140px', minWidth: 0 },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      width: '75%',
    },
  },
}));

export function TripArrayFieldDateInput({
  tripField,
  index,
  required,
}: {
  tripField: Extract<TripArrayFieldKey, 'appointmentDate' | 'pickupDate'>;
  index: number;
  required?: boolean;
}) {
  const { t } = useTranslation('common');
  const { control } = useFormContext<ReservationFormInput>();
  const { fieldRefs } = useReservationFormMachines();
  const actor = fieldRefs[tripField];
  useFieldActorSnapshot(actor);

  return (
    <StyledBox className={classes.container}>
      <DateInput
        label={t('member.date')}
        name={`trips.${index}.${tripField}`}
        control={control as unknown as Control<FieldValues>}
        required={required}
        inputWidth="100%"
        onFocus={() => actor.send({ type: 'FOCUS', index })}
        onChange={(date) => {
          const value = date?.toISODate() ?? '';
          actor.send({
            type: 'CHANGE',
            index,
            value,
          });
        }}
      />
    </StyledBox>
  );
}
